import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FaEye, FaUserCog } from "react-icons/fa";
import styles from "../master/academicConfiguration/AcademicCreate.module.css";
import AxiosInstance, { TokenService } from "../../../services/Api";
import { CustomButton, CustomDropdown } from "../../../components";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CustomMRTTable from "../../../components/CustomMRTTable/CustomMRTTable";
import tiemStyles from "./CreatetimetbListView.module.css";
import moment from "moment";
import PopupModal from "../../../components/PopupModal/PopupModal";
const CreateTimeTableList = () => {
  const navigate = useNavigate();
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || {};
  const school_id = clientData?.school_id || "";
  const master_id = clientData?.client_id || "";
  const end_date = clientData.end_date;
  const user_id = clientData.user_id;
  const start_date = clientData.start_date;
  const academic_year = clientData?.academic_year || "";
  const academic_year_id = clientData?.academic_year_id || "";
  /* ===========================
       LANGUAGE (MUST BE FIRST)
    =========================== */
  const { translations } = useSelector((state) => state.language);

  /* ===========================
       STATES
    =========================== */
  const [classValue, setClassValue] = useState("");
  const [sectionValue, setSectionValue] = useState("");
  const [shiftValue, setShiftValue] = useState("");
  const [dayList, setDayList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [scheduleData, setScheduleData] = useState({});
  const [subjectStaffData, setSubjectStaffData] = useState({});
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50, // timetable usually needs bigger page size
  });
  const [selectedDayMap, setSelectedDayMap] = useState({});

  const [data, setData] = useState([]);
  const [sectionList, setSectionList] = useState([]);
  const [staffMap, setStaffMap] = useState({});

  const [shiftList, setShiftList] = useState([]);
  const [errors, setErrors] = useState({});
  const [modalState, setModalState] = useState({
    open: false,
    type: "success", // "success" | "error"
    message: "",
    redirectPath: "",
  });

  const handleSuccessOk = () => {
    const { type, redirectPath } = modalState;

    setModalState((prev) => ({
      ...prev,
      open: false,
    }));

    if (type === "success" && redirectPath) {
      navigate(redirectPath);
    }
  };

  // API call to fetch class list
  const fetchClassList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(`/school/classList`, {
        id: school_id,
        academic_year: academic_year,
      });

      if (response?.data?.success) {
        const apiData = response.data.data || [];

        // Transform API data to match table structure
        const transformedData = apiData
          .filter((item) => item.domain_id !== "CLASS")
          .map((item) => ({
            id: item.id,
            class_id: item.class_id,
            class: item.domain_id,
            label: item.domain_id,
            value: item.class_id,
            maleCount: item.no_of_boys || 0,
            femaleCount: item.no_of_girls || 0,
            totalStudents: (item.no_of_boys || 0) + (item.no_of_girls || 0),
            noOfSection: item.no_of_section || 0,
          }));

        setData(transformedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching class list:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchSectionList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(
        `/school/timeTable/sectionDropdown `,
        {
          id: [classValue.class_id],
          school_id: school_id,
        },
      );

      if (response?.data?.status) {
        const apiData = response.data.data || [];
        const transformedData = apiData.map((item) => ({
          id: item.id,
          class_id: item.class_id,
          section: item.section_id,
          label: item.section_id,
          value: item.section_id,
        }));

        setSectionList(transformedData);
      } else {
        setSectionList([]);
      }
    } catch (error) {
      console.error("Error fetching class list:", error);
      setSectionList([]);
    } finally {
      setLoading(false);
    }
  };
  const fetchShiftList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.get(
        `/school/shiftList/${school_id}`,
      );
      if (response?.data?.status) {
        const apiData = response.data.data || [];
        // Transform API data to match table structure
        const transformedData = apiData.map((item) => ({
          value: item.id,
          label: item.shift_type,
        }));
        setShiftList(transformedData);
      } else {
        setShiftList([]);
      }
    } catch (error) {
      console.error("Error fetching class list:", error);
      setShiftList([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (classValue) {
      fetchSectionList();
    }
  }, [classValue]);
  useEffect(() => {
    if (school_id) {
      fetchClassList();
      fetchShiftList();
    }
  }, [school_id]);
  useEffect(() => {
    fetchScheduleList();
  }, []);
  const fetchScheduleList = useCallback(async () => {
    try {
      setLoading(true);
      const payload = {
        school_id: parseInt(school_id),
        academic_id: parseInt(academic_year_id),
        config_id: "",
        class_id: classValue || "",
      };
      const response = await AxiosInstance.post(
        "/exam/examSchedule/list",
        payload,
      );
      if (response?.data?.status) {
        setScheduleData(response.data.data || []);
      } else {
        setScheduleData([]);
      }
    } catch (error) {
      console.error("Error fetching schedule list:", error);
      setScheduleData([]);
    } finally {
      setLoading(false);
    }
  }, [school_id, classValue, shiftValue]);
  /* ===========================
       FETCH TABLE DATA
    =========================== */
  useEffect(() => {
    if (classValue && sectionValue && shiftValue) {
      fetchTimeTableSchool();
    }
  }, [classValue, sectionValue, shiftValue]);

  useEffect(() => {
    if (tableData.length === 0) {
      fetchDayList();
    }
  }, [tableData]);

  const fetchStaffList = async (subjectId) => {
    if (!subjectId) return;

    try {
      const response = await AxiosInstance.post("/school/staff/by-subject", {
        subject_id: parseInt(subjectId),
        school_id: school_id,
      });

      if (response?.data?.success) {
        const staffData = response.data.data || [];

        // Transform to dropdown format
        const formattedStaff = staffData.map((staff) => ({
          id: staff.id,
          name: staff.name, // 👈 make sure this matches API field
        }));

        setStaffMap((prev) => ({
          ...prev,
          [subjectId]: formattedStaff,
        }));
      }
    } catch (err) {
      console.error("Error fetching staff list:", err);
    }
  };

  const fetchDayList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post("/timeTable/dayList", {
        school_id: school_id,
        class_id: classValue.value,
        section: sectionValue.value,
        shift_id: shiftValue.value,
      });

      const apiData = response?.data?.data || [];

      if (response.data.status) {
        setDayList(apiData); // keep data internally
      } else {
        setDayList([]); // no record → allow table
      }
    } catch (error) {
      console.error("Error fetching day schedule", error);
      setDayList([]);
    } finally {
      setLoading(false);
    }
  };

  const getTodayWeekendId = () => {
    const today = new Date().getDay();

    return today === 0 ? 7 : today;
  };
  const fetchTimeTableSchool = async () => {
    setLoading(true);
    const weekendId = getTodayWeekendId();
    try {
      const response = await AxiosInstance.post("/timeTable/timeTableSchool", {
        school_id: school_id,
        class_id: classValue.value,
        section: sectionValue.value,
        //  shift_id: shiftValue.value,
        weekend_id: String(weekendId),
        dayid: "",
        shift_id: shiftValue.value,
        academic_year: academic_year_id,
        // weekend_id: weekendId
      });

      const apiData = response?.data?.data || [];

      if (apiData.length > 0) {
        alert("Record already exist!");
        setTableData(apiData); // keep data internally
      } else {
        setTableData([]); // no record → allow table
      }
    } catch (error) {
      console.error("Error fetching day schedule", error);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  const { formattedData, dynamicPeriods } = useMemo(() => {
    const ALL_DAYS = [
      { id: 1, name: "MONDAY" },
      { id: 2, name: "TUESDAY" },
      { id: 3, name: "WEDNESDAY" },
      { id: 4, name: "THURSDAY" },
      { id: 5, name: "FRIDAY" },
      { id: 6, name: "SATURDAY" },
      { id: 7, name: "SUNDAY" },
    ];

    // 👇 You can fix number of periods here
    const TOTAL_PERIODS = 8;
    const periodsArray = Array.from({ length: TOTAL_PERIODS }, (_, i) => i + 1);

    const rows = ALL_DAYS.map((day) => {
      const rowObj = {
        day: day.name,
        day_id: day.id,
        schedule: `Day ${day.id}`,
      };

      periodsArray.forEach((period) => {
        rowObj[`period_${period}`] = "";
      });

      return rowObj;
    });

    return {
      formattedData: rows,
      dynamicPeriods: periodsArray,
    };
  }, []);

  const handleDropdownChange = (field, value, setter) => {
    setter(value);
    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));

    // 👇 RESET DEPENDENT DROPDOWNS
    if (field === "classValue") {
      setSectionValue("");
      setSectionList([]);
    }
  };

  const handleScheduleChange = async (rowDayId, selectedDay) => {
    if (!selectedDay) return;

    setSelectedDayMap((prev) => ({
      ...prev,
      [rowDayId]: selectedDay,
    }));

    try {
      setLoading(true);

      const payload = {
        school_id: school_id,
        class_id: classValue.value,
        section: sectionValue.value,
        shift_id: shiftValue.value,
        day: Number(selectedDay),
      };

      const response = await AxiosInstance.post(
        "/timeTable/dayPeriodSubject",
        payload,
      );

      if (response?.data?.status) {
        const apiData = response.data.data || [];

        // ✅ store subject + period data
        // setSubjectStaffData((prev) => ({
        //   ...prev,
        //   [rowDayId]: apiData,
        // }));

        const resetTeachingData = apiData.map((item) => ({
          ...item,
          teaching_id: "", // 👈 force reset staff selection
        }));

        setSubjectStaffData((prev) => ({
          ...prev,
          [rowDayId]: resetTeachingData,
        }));

        // ✅ fetch staff for each unique subject id
        const uniqueSubjectIds = [...new Set(apiData.map((item) => item.id))];

        uniqueSubjectIds.forEach((subjectId) => {
          if (subjectId && !staffMap[subjectId]) {
            fetchStaffList(subjectId);
          }
        });
      } else {
        console.log("No data found");
      }
    } catch (error) {
      console.error("Error fetching day period subject:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStaffChange = async (rowDayId, period, staffId) => {
    try {
      setLoading(true);

      const numericStaffId = Number(staffId);

      // ✅ 1. Update UI immediately (important)
      setSubjectStaffData((prev) => {
        const updatedDayData = (prev[rowDayId] || []).map((item) => {
          if (item.period === period) {
            return {
              ...item,
              teaching_id: numericStaffId, // 👈 update selected value
            };
          }
          return item;
        });

        return {
          ...prev,
          [rowDayId]: updatedDayData,
        };
      });

      const payload = {
        id: 0,
        school_id: school_id,
        class_id: classValue.value,
        period: period,
        teaching_id: numericStaffId,
        day: rowDayId,
        start_date: start_date,
        end_date: end_date,
      };

      const response = await AxiosInstance.post(
        "/timeTable/timeTableCheck",
        payload,
      );

      if (response?.data?.status) {
        console.log("true");
      } else {
        alert(
          response?.data?.message || "Staff already assigned for this period",
        );
      }
    } catch (error) {
      console.error("Error checking timetable:", error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setClassValue("");
    setSectionValue("");
    navigate(-1);
  };
  const handleSubmit = async (e) => {
    const time_table = Object.keys(subjectStaffData).map((dayKey) => {
      const dayId = Number(dayKey);
      const dayRow = formattedData.find((d) => d.day_id === dayId);
      return {
        day: dayId,
        day_name: dayRow?.day || "",
        periods: subjectStaffData[dayKey].map((periodItem) => ({
          period: periodItem.period,
          teaching_id: Number(periodItem.teaching_id) || 0,
          course_id: Number(periodItem.course_id) || 0,
        })),
      };
    });
    e.preventDefault();
    const payload = {
      academic_year: academic_year_id,
      school_id: school_id,
      user_id: user_id,
      client_id: master_id,
      class_id: classValue.value || "",
      section: sectionValue.value,
      shift_id: shiftValue.value,
      start_date: moment(start_date).format("YYYY-MM-DD"),
      end_date: moment(end_date).format("YYYY-MM-DD"),

      time_table: time_table,
    };

    const response = await AxiosInstance.post(
      `/timeTable/timeTableCreate`,
      payload,
    );
    if (response.data?.status) {
      setModalState({
        open: true,
        type: "success",
        message: response.data?.message,
        redirectPath: "/user/createtimetbListView",
      });
    } else {
      setModalState({
        open: true,
        type: "error",
        message: response.data?.message,
        redirectPath: "",
      });
    }
  };

  const columns = useMemo(() => {
    if (!dynamicPeriods.length) return [];

    const periodColumns = dynamicPeriods.map((period) => ({
      accessorKey: `period_${period}`,
      header: `Period ${period}`,
      enableSorting: false,
      Cell: ({ row }) => {
        const rowDayId = row.original.day_id;
        const rowPeriodData = subjectStaffData[rowDayId] || [];

        const periodInfo = rowPeriodData.find((item) => item.period === period);
        const subjectId = periodInfo?.id;
        const staffListForSubject = staffMap[subjectId] || [];

        return (
          <div className={tiemStyles.periodContainer}>
            {/* Subject */}
            {periodInfo?.subject_name && (
              <div className={tiemStyles.subjectLabel}>
                {periodInfo.subject_name}
              </div>
            )}

            {/* Staff */}
            <select
              className={`form-select form-select-sm ${
                periodInfo?.teaching_id
                  ? tiemStyles.textOrange
                  : tiemStyles.textMuted
              }`}
              value={periodInfo?.teaching_id ?? ""}
              onChange={(e) =>
                handleStaffChange(rowDayId, period, e.target.value)
              }
            >
              <option value="">-Select Staff-</option>

              {staffListForSubject.map((staff) => (
                <option key={staff.id} value={staff.id}>
                  {staff.name}
                </option>
              ))}
            </select>
          </div>
        );
      },
    }));

    return [
      {
        accessorKey: "day",
        header: "Day",
        enableSorting: false,
      },
      {
        accessorKey: "schedule",
        header: "Schedule",
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <select
              className="form-select"
              defaultValue=""
              value={selectedDayMap[row.original.day_id] || ""}
              onChange={(e) =>
                handleScheduleChange(row.original.day_id, e.target.value)
              }
            >
              <option value="" disabled>
                -Select Day-
              </option>

              {dayList.map((item) => (
                <option key={item.day} value={item.day}>
                  Day {item.day}
                </option>
              ))}
            </select>
          );
        },
      },

      ...periodColumns,
    ];
  }, [dynamicPeriods, scheduleData, dayList, subjectStaffData, staffMap]);

  return (
    <>
      <PopupModal
        open={modalState.open}
        title={modalState.type === "success" ? "Success" : "Failed"}
        message={modalState.message}
        onOk={handleSuccessOk}
      />

      <div className={styles.container}>
        {/* Header */}
        {/* <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaUserCog />
        </div>
        <h1 className={styles.headerTitle}>
          {" "}
          {translations?.labels?.timeTableListTitle || "Time Table List"}
        </h1>
      </div> */}

        {/* FILTER CLASS */}

        <div className="row mb-4">
          {/* FILTER SHIFT */}

          <div className="col-lg-4 col-md-6 col-sm-12 px-2">
            <CustomDropdown
              label={translations?.labels?.shiftLabel}
              value={shiftValue}
              options={shiftList}
              onChange={(value) =>
                handleDropdownChange("shiftValue", value, setShiftValue)
              }
              placeholder={translations?.labels?.shiftPlaceholder}
              required
              error={errors.shiftValue}
            />
          </div>
          <div className="col-lg-4 col-md-6 col-sm-12 px-2">
            <CustomDropdown
              label={translations?.labels?.classLabel}
              value={classValue}
              options={data}
              onChange={(value) =>
                handleDropdownChange("classValue", value, setClassValue)
              }
              placeholder={translations?.labels?.classPlaceholder}
              required
              error={errors.classValue}
            />
          </div>
          {/* FILTER SECTION */}

          <div className="col-lg-4 col-md-6 col-sm-12 px-2">
            <CustomDropdown
              label={translations?.labels?.sectionLabel}
              value={sectionValue}
              options={sectionList}
              onChange={(value) =>
                handleDropdownChange("sectionValue", value, setSectionValue)
              }
              placeholder={translations?.labels?.sectionPlaceholder}
              required
              error={errors.sectionValue}
            />
          </div>
        </div>

        {/* ===========================
          TABLE (LOAD AFTER SELECT)
      =========================== */}
        {classValue && sectionValue && shiftValue && tableData.length === 0 && (
          <>
            <CustomMRTTable
              columns={columns}
              data={formattedData}
              loading={loading}
              pagination={pagination}
              onPaginationChange={setPagination}
              rowCount={formattedData.length}
              enablePagination={false}
              enableSearch={false}
              enableFiltering={false}
            />
            <div className="col-md-12">
              <div className="d-flex justify-content-center gap-3 mt-3">
                <CustomButton
                  variant="contained"
                  onClick={handleSubmit}
                  className={styles.saveButton}
                  fullWidth={false}
                  loading={loading}
                >
                  {translations.labels.saveButton}
                </CustomButton>

                <CustomButton
                  variant="contained"
                  onClick={handleCancel}
                  className={styles.cancelButton}
                  fullWidth={false}
                  disabled={loading}
                >
                  CANCEL
                </CustomButton>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CreateTimeTableList;
